export default "__VITE_ASSET__B5yeCZgT__"